module.exports = __webpack_public_path__ + "img/trash.5cb4b00e.svg";